import "./_Styles/ViewLayout.css";

/*
    Estructura unica de las vistas privadas.

    1) header   -> titulo de la seccion y, a la derecha, los botones de accion
    2) toolbar  -> banda reservada: buscador, filtros, exportar
    3) content  -> cards, tabla o registros

    La banda del toolbar se dibuja siempre, tenga o no contenido, para que
    todas las secciones arranquen a la misma altura. El alto minimo de 100vh
    evita que una seccion con dos registros se vea aplastada contra el pie.
*/

export const ViewLayout = ({ header, toolbar = null, children, isWide = false }) => (

    <div className="LStudio__app_view" data-wide={isWide}>

        <header className="LStudio__app_view__header">{header}</header>

        <div className="LStudio__app_view__toolbar" data-empty={!toolbar}>{toolbar}</div>

        <section className="LStudio__app_view__content">{children}</section>

    </div>
);
